module.exports = __webpack_public_path__ + "img/bot6.b802b679.svg";